"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontWeights = exports.fontSizes = void 0;
var fontSizes = {
    huge: "64px",
    xxxlarge: "32px",
    xxlarge: "28px",
    xlarge: "24px",
    regularLarge: "20px",
    regular: "14px",
    regularSmall: "13px",
    small: "12px",
    xsmall: "11px",
    xxsmall: "10px",
    xxxsmall: "9px",
    tiny: "8px",
};
exports.fontSizes = fontSizes;
var fontWeights = {
    bolder: 700,
    bold: 600,
    regular: 400,
    light: 200,
    lighter: 200,
};
exports.fontWeights = fontWeights;
//# sourceMappingURL=fonts.js.map